<app-header></app-header> 

<!-- Title -->
<div class="section-lg bg-image parallax" style="background-image: url('assets/images/backgrounds/title-bg-1.jpg');">
  <div class="bg-dark-07">
    <div class="container">
      <div class="row g-4">
        <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 text-center">
          <h1 class="fw-black m-0 display-4">Our Testimonials</h1>
          <h2 class="fw-thin uppercase">CREATIVE DIGITAL AGENCY SINCE 2004</h2>
        </div>
      </div><!-- end row -->
    </div><!-- end container -->
  </div>
</div>
<!-- end Title -->

<!-- Testimonial section -->
<div class="section">
  <div class="container">
    <div class="row">
      <div class="col-12 col-lg-12 heading-style-one text-center">
        <h6 class="yellow-color uppercase">Testimonials</h6>
        <h2 class="display-6 fw-black">Our Clients Saying About Us</h2>
      </div>
    </div>
    <owl-carousel-o [options]="testimonialOptions" class="owl-btn-center-lr mrt-80 testimonial-two pd-0">
      <ng-template carouselSlide *ngFor="let tes of testimonials">
          <!-- Testimonial box -->
          <div class="testimonial-item">
              <div class="testimonial-content">
                  <div class="testimonial-content-in">
                      <div class="img">
                          <img class="img-responsive border-radius-100" src="assets/images/team/{{tes.image}}" alt="client-img">
                      </div>
                      <h5>{{tes.name}}</h5>
                      <h6>{{tes.position}}</h6>
                      <p>{{tes.desc}}</p>
                  </div>
              </div>
          </div>
      </ng-template>
  </owl-carousel-o>
    <div class="row">
      <div class="col-md-12">
        <div class="triangle-yellow-big d-sm-block" data-opacity="0.1"></div>
      </div>
    </div>
  </div><!-- end container -->
</div>
<!-- end Testimonial section -->

<!-- Blogs section -->
<div class="section-lg">
  <div class="row">
    <div class="col-md-12">
      <div class="square-light-green-big shapes d-sm-block" data-opacity="0.1"></div>
    </div>
  </div>
  <div class="container">
    <div class="row">
      <div class="col-12 col-lg-12 heading-style-one text-center">
        <h6 class="yellow-color uppercase">Our Blogs</h6>
        <h2 class="display-6 fw-black">Check What Happening Inside Score</h2>
      </div>
    </div>
    <div class="row align-items-center mrt-50">
        <div class="col-md-4" *ngFor="let post of posts">
            <div class="post">
                <div class="post-img">
                    <img class="img-responsive" [src]="post.image" [alt]="post.title">
                </div>
                <div class="post-info">
                    <h3>
                        <a routerLink="/blog-grid">{{ post.title }}</a>
                    </h3>
                    <h6 [ngClass]="post.color">
                        {{ post.category }}
                    </h6>
                    <p>{{ post.time }}</p>
                    <a class="readmore" routerLink="/blog-grid">
                        <span>
                            Read More
                            <i class="eicon bi bi-arrow-right-short"></i>
                        </span>
                    </a>
                </div>
            </div>
        </div>
    </div>
  </div><!-- end container -->
</div>
<!-- end Blogs section -->

<footer class="footer footer-three">
  <div class="footer-main">
    <div class="container">
      <div class="row">
        <!-- ABOUT -->
        <div class="col-sm-6 col-md-3">
          <div class="widget widget-links">
            <h5 class="widget-title">About Us</h5>
            <div class="footer-about">
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                In at purus varius odio tempus cursus. vitae, commodo dui.
              </p>
              <ul class="social-media">
                <li *ngFor="let social of socialLinks">
                  <a [href]="social.url" class="bi" [ngClass]="social.icon"></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- QUICK LINKS -->
        <div class="col-sm-6 col-md-2">
          <div class="widget widget-links">
            <h5 class="widget-title">Quick Links</h5>
            <ul>
              <li *ngFor="let link of quickLinks">
                <a [href]="link.url">{{link.name}}</a>
              </li>
            </ul>
          </div>
        </div>
        <!-- RECENT POSTS -->
        <div class="col-sm-6 col-md-4">
          <div class="widget widget-links">
            <h5 class="widget-title">Recent Post</h5>
            <div class="row post-sm-content" *ngFor="let post of recentPosts; let i=index" [class.mrt-20]="i > 0">
              <div class="col-md-3 col-sm-3 col-xs-3">
                <img class="img-overlay border-radius-100" [src]="post.image" alt="post">
              </div>
              <div class="col-md-9 col-sm-9 col-xs-9">
                <h6>{{post.title}}</h6>
                <p>{{post.desc}}</p>
              </div>
            </div>
          </div>
        </div>
        <!-- CONTACT -->
        <div class="col-sm-6 col-md-3">
          <div class="widget widget-text">
            <h5 class="widget-title">Contact Us</h5>
            <ul class="footer-contact">
              <li>
                <i class="bi bi-pin-fill"></i>
                <p>Schönhauser Allee 167c 10435 Berlin Germany</p>
              </li>
              <li>
                <i class="bi bi-envelope"></i>
                <p>
                  <a href="mailto:yoursite@gmail.com">
                    yoursite&#64;gmail.com
                  </a>
                </p>
              </li>
              <li>
                <i class="bi bi-phone-fill"></i>
                <p>+49 30 47373795</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>


  <!-- COPYRIGHT -->
  <div class="footer-copyright">

    <div class="container">

      <div class="row d-flex justify-content-center">
        <div class="col-md-2">

          <div class="logo-footer">
            <a routerLink="/">
              <img class="img-responsive" src="assets/images/logo-footer.png" alt="footer-logo">
            </a>
          </div>

        </div>
      </div>


      <div class="row">
        <div class="col-md-12">

          <div class="copy-right"> © Copyright 2026 Chaos. Designed By <a href="https://themeforest.net/user/designsninja/portfolio" target="_blank">
              DesignsNinja
            </a>
          </div>

        </div>
      </div>

    </div>

  </div>

</footer>